

// https://www.zhihu.com/question/276201177
// import './plugins/vConsole.js' // 引入后下面的才会打印出来，放第一个吧 //!! IE 不可用
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import 'babel-polyfill' // noah add 0329

// import "es6-proxy-polyfill";// noah modify cancel // 0329

import cssVars from 'css-vars-ponyfill'

import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'

// ====================
// Vue.prototype.$hx = {} //import 应该是异步或者变量提升了,$hx会报undefined。。。
// window.$hx = Vue.prototype.$hx
// ====================
// import "./plugins/vConsole.js"; //引入后下面的才会打印出来 //!! IE 不可用
import './plugins/getUrlParam.js' // 尽量放前面
import './plugins/aes/install.js' // vuex 使用了AES 放前面

import router from './router'
import store from './store'

// 引入vuex简写方法
import vuexStore from '@/store/mixin.js'

// 引入动画库
import 'animate.css'

// 有时候不一定会用UI库
// if (process.env.VUE_APP_SYSUINAME) {
//   //!! IE 用 await import() 报 缺少')'
//   // await import(`./plugins/${process.env.VUE_APP_SYSUINAME}.js`);
//   require(`./plugins/${process.env.VUE_APP_SYSUINAME}.js`);
// }
// import "./plugins/element-ui.js";


/* elemnt-ui 按需引入
import { Pagination} from 'element-ui'
import 'element-ui/lib/theme-chalk/pagination.css';
import 'element-ui/lib/theme-chalk/icon.css';
Vue.use(Pagination) */


import './plugins/vant.js'

import './plugins/axios.js'

// 需要在main.js添加一句代码过滤掉wx-open-launch-weapp组件声明，不然会报wx-open-launch-weapp未定义的错误！！！！重要
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// 百度统计 百度埋点
import trackEvent from './plugins/trackEvent.js'
Vue.directive('trackEvent', trackEvent)

cssVars({
  // shadowDOM: true,
  // preserveVars: true, //确定转换后的CSS中是否保留CSS自定义属性声明。
})
// let vuexStore = require('@/store/mixin.js')
Vue.mixin(vuexStore) // 里面有UI库的消息组件，放vant后面

// import "./myUniSDK/install.js";
Vue.prototype.$myUniSDK = {}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
